import axios from "axios";

export default function getReassignHistory(payload) {
  return new Promise((resolve, reject) =>
    axios
      .post("/distributor/system-admin/api/v1/reassign-history", {
        start: payload.start,
        length: payload.length,
        order: payload.order,
        column: payload.column,
        company_uuid: payload.company_uuid,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
